var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-icon tt-next-day-icon"},[_c('img',{attrs:{"src":require("@/assets/icons-new/stop-delivery.png"),"alt":"stop-delivery"}}),_c('div',{staticClass:"tt-tooltip"},[_vm._v(" "+_vm._s(_vm.$t('main_vpopup_available_for_pickup'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }